import { createAsyncThunk } from "@reduxjs/toolkit";
import { agent } from "../../../api";
import { addNotification } from "../../Notification/notificateStore";
import { casesUrl } from "../casesReducer";
import { CasesEntity, CasesEntityResponse } from "../../../entities/cases_v2";
import { handlerNeedUpdate } from "../casesTableStore";

export const getCasesEntity = createAsyncThunk(
  'cases/get-entity-by-id',
  async (param: { id: number }): Promise<CasesEntity> => {
    try {
      const response = await agent.get(`${casesUrl}/read/${param.id}`)
      if (response.ok) {
        const data = await response.json() as CasesEntity;
        return data;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const postCasesEntity = createAsyncThunk(
  'cases/post-entity',
  async (param: { data: any }, thunksApi): Promise<CasesEntity> => {
    try {
      const {status, ...body} = param.data
      const response = await agent.post(`${casesUrl}/create/from-global-settings`, {
        body: JSON.stringify(body)
      })
      if (response.ok) {
        const data = await response.json() as CasesEntity;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'entity', value: true }));

        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)

export const patchCasesEntity = createAsyncThunk(
  'cases/patch-entity-by-id',
  async (param: { data: CasesEntityResponse, id: number }, thunksApi): Promise<CasesEntity> => {
    try {
      const response = await agent.patch(`${casesUrl}/update/from-config-part/${param.id}`, {
        body: JSON.stringify(param.data)
      })
      if (response.ok) {
        const data = await response.json() as CasesEntity;
        thunksApi.dispatch(
          addNotification({ status: "success", text: "Successfully saved" })
        );
        thunksApi.dispatch(handlerNeedUpdate({ key: 'entity', value: true }));
        return data;
      }
      if (!response.ok) {
        const result = await response.json() as { message: string }
        thunksApi.dispatch(addNotification({ status: 'error', text: result.message }))
        throw result.message;
      }
      throw Error("No response");
    } catch (error) {
      throw Error("Request is not found");
    }
  }
)